import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { TabMenu } from "primereact/tabmenu";
import { IndexPrecodedTexts } from "../../precodedTexts/IndexPrecodedTexts";
import { IndexTypePrecodedTexts } from "../../precodedTexts/IndexTypePrecodedTexts";

export const IndexPrecodedText = (props) => {
  const [activeIndex, setActiveIndex] = useState(() => {
    const savedIndex = localStorage.getItem("activeIndexPrecodedText");
    return savedIndex ? parseInt(savedIndex, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem("activeIndexPrecodedText", activeIndex);
  }, [activeIndex]);

  const items = [
    { label: "Tipos de textos precodificados"},
    { label: "Textos precodificados" },
  ];

  const handleTabChange = (e) => {
    setActiveIndex(e.index);
  };

  return (
    <Fragment>
      <div className='container-global-zoom'>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-2">
                <TabMenu
                    model={items}
                    activeIndex={activeIndex}
                    onTabChange={handleTabChange}
                    className="custom-tabmenu full-width custom-tabmenu-orange"                
                />

                <div style={{ marginTop: "1rem" }}>
                    <div style={{ display: activeIndex === 0 ? "block" : "none" }}>
                        <IndexTypePrecodedTexts {...props} />
                    </div>
                    <div style={{ display: activeIndex === 1 ? "block" : "none" }}>
                        <IndexPrecodedTexts {...props} />
                    </div>
                 </div>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};
